import { StandardEvents } from '@shopify/events';
import { formatMoney } from '@theme/money-formatting';

const SELECTOR = '[data-narda-free-shipping-progress]';
const MESSAGE_SELECTOR = '.free-shipping-progress__message span:last-child';

/**
 * @param {HTMLElement} element
 * @param {number} cartTotal
 */
function updateProgress(element, cartTotal) {
  const threshold = Number(element.dataset.thresholdCents || 0);
  if (!threshold) return;

  const remaining = threshold - cartTotal;
  const progress = Math.min(100, Math.max(0, (cartTotal / threshold) * 100));
  const reached = remaining <= 0;
  const moneyFormat = element.dataset.moneyFormat || '${{amount}}';
  const currency = element.dataset.currency || 'MXN';
  const remainingText = element.dataset.remainingText || 'Agrega [amount] mas para obtener envio gratuito';
  const successText = element.dataset.successText || 'Felicidades, ya tienes envio gratuito';
  const amount = formatMoney(Math.max(remaining, 0), moneyFormat, currency).replace(/\.00\b/, '');
  const message = reached ? successText : remainingText.replace('[amount]', amount);

  element.classList.toggle('free-shipping-progress--success', reached);
  element.querySelector('[data-narda-free-shipping-fill]')?.style.setProperty('--free-shipping-progress', `${progress}%`);

  const messageElement = element.querySelector(MESSAGE_SELECTOR);
  if (messageElement) messageElement.textContent = message;

  const bar = element.querySelector('[role="progressbar"]');
  bar?.setAttribute('aria-label', message);
  bar?.setAttribute('aria-valuenow', String(Math.min(cartTotal, threshold)));
}

/**
 * @param {number} cartTotal
 */
function updateAll(cartTotal) {
  document.querySelectorAll(SELECTOR).forEach((element) => {
    if (element instanceof HTMLElement) updateProgress(element, cartTotal);
  });
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise
    ?.then(({ cart }) => {
      const storefrontTotal = cart?.cost?.totalAmount?.amount;
      const cartTotal =
        storefrontTotal != null ? Math.round(Number(storefrontTotal) * 100) : Number(cart?.total_price ?? 0);
      updateAll(cartTotal);
    })
    .catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[narda-free-shipping-progress] Cart update failed:', error);
    });
});
